import { Component, OnInit, ViewChild } from '@angular/core';
import { LanguagesService } from 'src/app/services/language.service';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { BaseService } from 'src/app/services/base.service';
import { TranslateService } from '@ngx-translate/core';
import { TabsComponent } from '../tabs-control/tabs-control.component';
import { Title } from '@angular/platform-browser';
import { HeadFamilyComponent } from './head-family.component';
import { PartnerDataComponent } from './partner-data.component';
import { ChildrenDataComponent } from './children-data.component';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { RecaptchaService } from 'src/app/services/recaptcha.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {
  form: FormGroup = null;
  msgBoxTitle: string = "";
  message = "";
  lastWorkItems: FormArray = null;
  public children_up18_number = 0;
  childrenList;
  HatzharaList;
  myContact;
  mate;
  Tabs = null;
  isFinishedSuccessfuly = false;
  showCaptcha = false;
  public isSubmited = false;
  isError = false;
  @ViewChild(TabsComponent) private tabsComponent: TabsComponent;
  @ViewChild(HeadFamilyComponent) private headFamilyComponent: HeadFamilyComponent;
  @ViewChild(PartnerDataComponent) private partnerDataComponent: PartnerDataComponent;
  @ViewChild(ChildrenDataComponent) private childrenDataComponent: ChildrenDataComponent;

  constructor(
      public languagesService: LanguagesService,
      private translate: TranslateService,
      private titleService: Title,
      public router: Router,
      private configService: ConfigService,
    public baseService: BaseService,
    public captchaV3Service: RecaptchaService) {
      this.Tabs = [
      { Title: "registration-form.tabs.head-data", isShow: false, Content: 'tabHeadData' },
      { Title: "registration-form.tabs.partner-data", isShow: false, Content: 'tabPartnerData' },
      { Title: "registration-form.tabs.childrenup18", isShow: false, Content: 'tabChildrenUp18Data' }
      ];
    this.Tabs[0].Title = "פרטי <br>ממלא הטופס"
    this.Tabs[1].Title = "פרטי <br>בן/בת הזוג"
    this.Tabs[2].Title = "פרטי ילדים <br>בגילאי 16-18"
      this.titleService.setTitle("טופס הרשמה");
      this.createFormControl();
  }

  createFormControl() {
    this.form = new FormGroup({
      form_HeadFamilyData: new FormGroup({}),
      form_PartnerData: new FormGroup({}),
      form_ChildrenUp18Data: new FormGroup({}),
      captcha: new FormControl('')
    });
  }

  public get f() {
    return this.form.controls;  
  }

  public get fp() {
    let pf: FormGroup = this.form.controls.partnerForm as FormGroup;
    return pf.controls;
  }

  ngOnInit(): void {
    this.msgBoxTitle = "טופס הרשמה";
  }

  activTabChanged() {
    if (this.tabsComponent) {
      if (this.Tabs[this.tabsComponent.idxActive].Content == 'tabChildrenUp18Data')
          this.children_up18_number = Number(this.form.value.form_HeadFamilyData.children_up18_num); 
      if (this.Tabs[this.tabsComponent.idxActive].Content == 'tabPartnerData')
          this.baseService.setPartnerProperty(this.form);
    }      
  }

  onSubmit() {
    this.baseService.clearMainErrorMessage();
    if (this.tabsComponent) {
      switch (this.Tabs[this.tabsComponent.idxActive].Content) {
        case 'tabHeadData':
            if (this.headFamilyComponent.onSubmit()) {
              this.isSubmited = true;
              this.tabsComponent.gotoNextTab();
            }            
          break;

        case 'tabPartnerData':
            if (this.partnerDataComponent.onSubmit())
              this.tabsComponent.gotoNextTab();
          break;

        case 'tabChildrenUp18Data':
            if (this.childrenDataComponent.onSubmit())
              this.tabsComponent.gotoNextTab();
          break;
      }
    }
  }

  onReset() {
    this.router.navigateByUrl(`/`).then(
      () => { this.router.navigateByUrl('/registration'); });
  }  

  ShowTab(event) {
    if (event.tabIdx) {
      if (event.isShow)
        this.Tabs[0].isShow = true;

      this.Tabs[event.tabIdx].isShow = event.isShow;
    }
  }

  NextTab() {
    this.tabsComponent.gotoNextTab();
  }

  activateTab(tabIdx) {
    if (this.tabsComponent.idxActive != tabIdx)
      this.tabsComponent.showTabContent(tabIdx);

    window.scroll(0, 0);
    if (this.baseService.errMessage == '')
      switch (tabIdx) {
        case 0:
            this.baseService.invalidTabName = 'פרטי <br>ממלא הטופס';
          break;
        case 1:
            this.baseService.invalidTabName = 'פרטי <br>בן/בת הזוג';
          break;
        case 2:
            this.baseService.invalidTabName = 'פרטי ילדים <br>בגילאי 16-18';
          break;
      }
  }

  getNormaldate(date: Date) {
    if (date) {
      var r = new Date((date.getTime() - date.getTimezoneOffset() * 60000));
      var convertDate = r.toISOString().substring(0, 10) + "T00:00:00Z";
      return convertDate;
    }
    return '01/01/0001';
  }

  CreateHatzharaList(lastWorkItems) {
    this.HatzharaList = new Array<any>();
    for (let i = 0; i < lastWorkItems.length; i++) {
      let htzr = {
        "uid":0,
        "familyRelation":lastWorkItems[i].family_relation,
        "workDescription":lastWorkItems[i].didnt_work?"לא עבדתי": lastWorkItems[i].job_place,
        "dateOfResignation":lastWorkItems[i].didnt_work?"01/01/0001": this.getNormaldate(lastWorkItems[i].finish_date)
      }
      this.HatzharaList.push(htzr);
     }
  }
  CreateChildrenList(ChildrenData) {
    if (ChildrenData.length > 0) {
      this.childrenList = new Array();
      for (let i = 0; i < ChildrenData.length; i++) {
        let child = {
          "idNumber":ChildrenData[i].social_id,
          "hebrewFisrtName":ChildrenData[i].first_name,
          "hebrewLastName":ChildrenData[i].last_name,
          "englishFirstName":ChildrenData[i].first_name_eng,
          "englishLastName":ChildrenData[i].last_name_eng,
          "sex":ChildrenData[i].sex,
          "statusBaaretzCode": Number(ChildrenData[i].israely_status),
          "statusBaaretzDescription":this.baseService.IsraelyStatus.find(s=> s.KOD == ChildrenData[i].israely_status).TEUR,
          "birthDate": this.getNormaldate(ChildrenData[i].birth_date),
          "exitDate": this.getNormaldate(ChildrenData[i].israely_status!=1?"01/01/0001":ChildrenData[i].departure_date),
          "kirva": 3,
          "backDate": this.getNormaldate(ChildrenData[i].returning_date),
          "contactInformation" :this.myContact,
          "birthCountry":ChildrenData[i].borne_israel
        }      
        this.childrenList.push(child);
      }
    }
  }

  CreateMateStruct(mateData) {
    this.CreateHatzharaList(mateData.lastWorkItems)
    let mat = {
    "idNumber":mateData.israely_status==1 ? mateData.social_id : 0,
    "hebrewFisrtName":mateData.first_name,
    "hebrewLastName":mateData.last_name,
    "englishFirstName":mateData.first_name_eng,
    "englishLastName":mateData.last_name_eng,
    "sex":mateData.sex,
    "statusBaaretzCode": Number(mateData.israely_status),
    "statusBaaretzDescription":this.baseService.IsraelyStatus.find(s=> s.KOD == mateData.israely_status).TEUR,
    "birthDate": this.getNormaldate(mateData.birth_date),
    "exitDate": this.getNormaldate(mateData.departure_date),
    "kirva": 2,
    "backDate": this.getNormaldate(mateData.returning_date),
    "sherut":mateData.israely_status==1? mateData.army_service:0,
    "sherutSiba":mateData.content,
    "expectedDateToReturn": this.getNormaldate(mateData.returning_date),
    "alreadyGotAssitenceOle": mateData.moia_donation, 
    "alreadyGotAssitenceHozer": mateData.returning_donation, 
    "hatzhara":this.HatzharaList,
    "contactInformation" :this.myContact,
    "mahasikIsraeli": Number(mateData.gov_check)
    };
    this.mate = mat;
  }
    
  CreateContactStruct(HFD) {
    let Contact = {
      "primaryPhone":HFD.phone_main,
      "secondaryPhone":HFD.phone_adv,
      "emailAddress":HFD.email,
      'expectedLivingCityCode':HFD.probable_city,
      'expectedLivingCityDescription':this.baseService.IsraelCities.find(c=>c.KOD == HFD.probable_city).TEUR,
      "livingCountryCode":HFD.residence_country,
      "livingCountryDescription":this.baseService.Countries.find(c=>c.KOD == HFD.residence_country).TEUR,
      "livingStateCode":HFD.state ? HFD.state : null,
      "livingStateDescription": HFD.state? this.baseService.USA_States.find(c=>c.KOD == HFD.state).TEUR:"",
      "city":HFD.city,
    }
    this.myContact = Contact;
  }

  finish() {    
    let HFD = this.form.value.form_HeadFamilyData;
    let partnerIsReturning = (HFD.marital_status == 2) && (HFD.partner_returning == 1);
    
    if (!(this.headFamilyComponent.isValid() && (!partnerIsReturning || this.partnerDataComponent.isValid()) && 
          this.childrenDataComponent.isValid()))
      return;

 
    this.form.value.captcha = "";
    let mateData = this.form.value.form_PartnerData;
    let CData = this.form.value.form_ChildrenUp18Data;

    try {
      this.CreateHatzharaList(HFD.lastWorkItems)
      let newform = {
        familyHead: {
          "idNumber": HFD.social_id,
          "hebrewFisrtName": HFD.first_name,
          "hebrewLastName": HFD.last_name,
          "englishFirstName": HFD.first_name_eng,
          "englishLastName": HFD.last_name_eng,
          "sex": HFD.sex,  //1=male, 2=female
          "statusBaaretzCode": 1, //israely
          "statusBaaretzDescription": this.baseService.IsraelyStatus.find(s=> s.KOD == 1).TEUR,
          "expectedDateToReturn":  this.getNormaldate(HFD.returning_date),
          "birthDate": this.getNormaldate( HFD.birth_date),
          "exitDate": this.getNormaldate(HFD.departure_date),
          "kirva": 1, // head = 1, partner = 2, child = 3
          "mateReturn": (HFD.partner_returning == '1'),
          //ContactInformation
          "sherut": HFD.army_service,
          "sherutSiba": HFD.content,
          //"taasuka": 
          "familyStatus": HFD.marital_status, 
          "backDate": this.getNormaldate( HFD.returning_date),
          "kidsBelow16": HFD.children_up16_num == "" ? "0" : HFD.children_up16_num, 
          "kidsBetween1618": HFD.children_up18_num == "" ? "0" : HFD.children_up18_num, 
          "alreadyGotAssitenceOle": HFD.moia_donation, 
          "alreadyGotAssitenceHozer": HFD.returning_donation, 
          "isScientist": HFD.scientist,
          "hatzhara": this.HatzharaList,
          "mahasikIsraeli": Number(HFD.gov_check),
          "contactInformation":{}
        },
        mate: null,
        children: null
      };

      this.CreateContactStruct(HFD);
      newform.familyHead.contactInformation = this.myContact;
      newform.mate = null;
      if (partnerIsReturning)
      {
        this.CreateMateStruct(mateData)
        newform.mate = this.mate;
      }         

      this.CreateChildrenList(CData.childrenItems)
      newform.children = this.childrenList;

      this.form.controls.declaration_check.setValue(false);
      this.isError = false;
      this.message = "בבקשה להמתין לשליחת הנתונים..." //this.translate.instant("please-wait");
      this.captchaV3Service.executeRecaptcha("SaveForm").subscribe((token: string) => {
        this.form.value.captcha = token
        this.baseService.SaveForm(newform, this.form.value.captcha).subscribe((res: string) => {
          if (res.toLocaleUpperCase().indexOf("ERROR") < 0) {
          this.isFinishedSuccessfuly = true;
          let FamilyIdentity = res;
          this.message = "";
          // this.baseService.getHozrim('MezaheMishpaha', FamilyIdentity).subscribe ((res2: any[]) => {
          //   if (res2.length > 0) {
                this.baseService.LoggedUser = {/*MEZAHE_ZAFUY_INTERNET: res2[0].MEZAHE_ZAFUY_INTERNET,*/ MISPAR_ZEHUT: newform.familyHead.idNumber, MIN: newform.familyHead.sex, 
                  SHEM_PRATI: newform.familyHead.hebrewFisrtName, SHEM_MISHPAHA: newform.familyHead.hebrewLastName};
                this.baseService.LoggedUserPartner = newform.mate /*&& ((res2.length > 1) && (res2[1].KIRVAH == "2"))*/ ? 
                  {/*MEZAHE_ZAFUY_INTERNET: res2[1].MEZAHE_ZAFUY_INTERNET,*/ MISPAR_ZEHUT: newform.mate.IdNumber, MIN: newform.mate.Sex, 
                    SHEM_PRATI: newform.mate.HebrewFisrtName, SHEM_MISHPAHA: newform.mate.HebrewLastName} : null;
                this.baseService.loginWay = false;
                this.router.navigate(['/welcome']); 
          //   }
          // });             
        }            
        else {
          this.formSavingWasFailed(res.toLocaleUpperCase().indexOf("ERROR ID") >= 0);
        }  
        });          
      });
    }
    catch {
      this.formSavingWasFailed();
    }  
  }

  formSavingWasFailed(isID_err = false) {
    this.form.controls.declaration_check.enable();
    this.form.controls.declaration_check.setValue(true);
    this.isError = true;
    if (isID_err)
      this.message = "לא ניתן להשלים את הפעולה";
    else
      this.message = "ארעה תקלה, נסה שנית מאוחר יותר";
  }
}
